import cx from 'classnames'

import type { BingoRoomJackpot } from 'store/modules/bingo/types'
import type { JackpotCurrency } from 'store/modules/jackpotsFromProviders/types'
import { parseJackpotSafe } from 'utils/jackpot'

import BingoJackpotTicker from '../components/BingoJackpotTicker'
import classes from '../styles.module.scss'

// Above this value the ticker badge switches to a compact layout to prevent overflow
const LARGE_JACKPOT_THRESHOLD = 10_000

type Params = {
  bingoRoomJackpot: BingoRoomJackpot | null
}

export function useBingoTileBadges({ bingoRoomJackpot }: Params) {
  const jackpotAmount = parseJackpotSafe(bingoRoomJackpot?.jackpotPrize)
  const rawCurrency = bingoRoomJackpot?.currency
  const jackpotCurrency: JackpotCurrency | null = rawCurrency === 'GC' || rawCurrency === 'SC' ? rawCurrency : null
  const isLargeJackpot = jackpotAmount != null && jackpotAmount > LARGE_JACKPOT_THRESHOLD

  const jackpotTicker =
    jackpotAmount != null && jackpotCurrency != null ? (
      <BingoJackpotTicker
        amount={jackpotAmount}
        currency={jackpotCurrency}
        className={cx(classes.tagItem, classes.tagJackpot, isLargeJackpot && classes.tagJackpotLarge)}
      />
    ) : null

  return { jackpotTicker }
}
